// API Configuration
// Production API URL
const PRODUCTION_API_URL = 'https://character-ai-app-635021ffeebd.herokuapp.com';

// Check if this is a production build
const isProductionBuild = process.env.NODE_ENV === 'production';

// Automatically detects localhost or uses environment variable
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '';

// Priority: 
// 1) Production build always uses production API
// 2) Hostname detection (for runtime)
// 3) Environment variable
// 4) Production default
let API_BASE_URL;

if (isProductionBuild) {
  // Production build: always use production API
  API_BASE_URL = PRODUCTION_API_URL;
} else if (isLocalhost) {
  // Development mode on localhost: ALWAYS use local API (ignore env variable)
  // This ensures local testing works regardless of env vars
  API_BASE_URL = 'http://localhost:5051';
} else {
  // Runtime production (not a build, but running in production environment)
  // Always use production API (ignore env variable if it's localhost)
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl && !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1')) {
    // Use env variable if it's not localhost
    API_BASE_URL = envUrl;
  } else {
    // Default to production API
    API_BASE_URL = PRODUCTION_API_URL;
  }
}

// Log for debugging (always log in production too to help diagnose issues)
console.log('[API Config] NODE_ENV:', process.env.NODE_ENV);
console.log('[API Config] Is Production Build:', isProductionBuild);
console.log('[API Config] Hostname:', window.location.hostname);
console.log('[API Config] Using:', API_BASE_URL);
console.log('[API Config] Environment:', isLocalhost ? 'LOCAL' : 'PRODUCTION');
if (process.env.REACT_APP_API_URL) {
  console.log('[API Config] Env variable set to:', process.env.REACT_APP_API_URL);
}

export default API_BASE_URL;

